import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getAllSalesFunnelsEndpoint } from "~/modules/client/api/salesFunnel/salesFunnelApiEndpoints.ts";
import type { SalesFunnel } from "~/modules/client/api/salesFunnel/salesFunnelTypes.ts";

export const getAllSalesFunnels = (): AxiosApiResponsePromise<SalesFunnel[]> =>
	axiosApi.get(getAllSalesFunnelsEndpoint);
